<template>
  <div style="margin-top: 20px;">
    <!-- <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading> -->
    <div class="container maincontent">
      <!-- <div class="col-md-12"> -->
        <div class="row postdata">
          <div class="col" style="margin-top:20px">
            <div class="nav">
              <div class="box-header">
                <h3 class="box-title pageTitle">Feedback</h3>
              </div>
              <hr class="myline" />
              <div class="card">
                <div class="myIntRes">
                  <div class="card-header p-2 tabHeader">
                  </div>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="active tab-pane" id="sent">
                      <div class="box-header with-border filterdata">
                        <input
                          v-model="postsearch"
                          @keyup="getDatas()"
                          type="text"
                          class="form-control pull-left search-text"
                          placeholder="Search"
                          style="width:50%;height:30%"
                        />
                        <div style="width:50%;" class="pull-right filterby">
                          <div class="form-group">
                            <div
                              class="form-select pull-right"
                              style="width: 50%;;height:30%"
                            >
                              <select
                                @change="getDatas()"
                                v-model="postsort"
                                class="form-control input-sm"
                              >
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                              </select>
                              <span class="select-icon"
                                ><i class="fa fa-chevron-down"></i
                              ></span>
                            </div>
                          </div>
                          <span class="pull-right ml-1">Sort by</span>
                        </div>
                      </div>
                      <div class="text-center">
                        <div class="box-body">
                          <ul
                            style="list-style: none"
                            v-for="(list, index) in feedbackListing"
                            :key="index"
                          >
                            <li class="myPostArea">
                              <!-- <div class="postBg"> -->
                              <div class="postArea">
                                <div
                                  type="button"
                                  data-toggle="modal"
                                  data-target="#mypost"
                                  @click="feedbackDetail(list, index)"
                                  class=" myorgData"
                                >
                                  <div class="Orgimage">
                                    <img
                                      class="round"
                                      v-if="
                                        list.profile_picture != '' &&
                                        list.profile_picture != null
                                      "
                                      :src="`${list.profile_picture}`"
                                      alt=""
                                    />
                                    <img
                                      class="round"
                                      v-if="
                                        list.profile_picture == '' ||
                                        list.profile_picture == null
                                      "
                                      src="../../../assets/img/default.png"
                                      alt=""
                                    />
                                    <!-- <img
                                      class="round"
                                      src="https://images.unsplash.com/photo-1657524432873-c37d2ac7b8cb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                                      alt=""
                                    /> -->
                                  </div>
                                  <div class="intDetails">
                                    <div class="uniqueId">
                                      <div class="Orgname">
                                        <strong>{{ list.organization }}</strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="position">
                                  <div class="val ">
                                    <label for="" class="labelcss">Position: </label>
                                    <div style="font-size:14px">
                                      <p class="mytitle">{{ list.job_tittle }}</p>
                                    </div>
                                  </div>
                                  <div class="val">
                                    <label for="" class="labelcss">Primary Skills:</label>
                                    <p class="mytitle hidepara">{{ list.primaryskillnames }}</p>
                                  </div>
                                </div>
                                <div class="interestbtn">
                                  <!-- <div class="openStatus">
                                          <button class="btn btn-success">Open</button>
</div> -->
                                  <div class="mystatus1">
                                    <label for="" class="labelcss">Status:</label>
                                    <span v-if="list.feedback_status == 'Completed'" style="color: #5bad2b" class="mytitle">Completed</span>
                                    <span v-if="list.feedback_status == 'Pending'" style="color: #ff2627" class="mytitle">Pending</span>
                                  </div>
                                  <!-- <br> -->
                                  <div class="Intcost">
                                    <label for="" class="labelcss">InterView Cost:</label>
                                    <p class="mystatus ">
                                      {{ list.currency_symbol }} {{ list.cost }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <hr style="margin-top:2px; margin-bottom:6px" />
                              <div class="timeofInterest">
                                <div class="val">
                                          <label for="" class="labelcss">Validity -</label>
                                          <p class="valdate">
                                            {{
                                              list.post_validity | formatDate
                                            }}
                                          </p>
                                        </div>
                                        <div class="val">
                                <label class="labelcss">Interviewed Date & Time -</label>
                                <p class="valdate">{{ list.schedule_date | formatDate }} - {{ list.schedule_start_time }} -
                  {{ list.schedule_end_time }} </p>
                  </div>
                              </div>
                              <!-- </div> -->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!--  individual -->
                    <div class="tab-pane" id="received">
                      <div class="box-header with-border filterdata">
                        <input
                          v-model="postsearch"
                          @keyup="getDatas()"
                          type="text"
                          class="form-control pull-left search-text"
                          placeholder="Search"
                          style="width:50%;height:30%"
                        />
                        <div style="width:50%;" class="pull-right filterby">
                          <div class="form-group">
                            <div
                              class="form-select pull-right"
                              style="width: 50%;;height:30%"
                            >
                              <select
                                @change="getDatas()"
                                v-model="postsort"
                                class="form-control input-sm"
                              >
                                <option value="7">Last 7 days</option>
                                <option value="0">Last 30 days</option>
                              </select>
                              <span class="select-icon"
                                ><i class="fa fa-chevron-down"></i
                              ></span>
                            </div>
                          </div>
                          <span class="pull-right ml-1">Sort by</span>
                        </div>
                      </div>
                      <div class="text-center">
                        <div class="box-body">
                          <div class="postBg">
                            <div class="postArea">
                              <div
                                type="button"
                                data-toggle="modal"
                                data-target="#mypost2"
                                @click="feedbackDetail()"
                                class="btn myorgData"
                              >
                                <div class="Orgimage">
                                 <img
                    class="profile-user-img img-fluid img-circle myprofile"
                    v-if="
                      details.profile_picture != '' &&
                      details.profile_picture != null
                    "
                    :src="`${details.profile_picture}`"
                    alt=""
                  />
                  <img
                    class="round"
                    v-if="
                      details.profile_picture == '' ||
                      details.profile_picture == null
                    "
                    src="../../../assets/img/default.png"
                    alt=""
                  />
                                </div>
                                <div class="intDetails">
                                  <div class="uniqueId">
                                    <div style="font-size:14px">
                                      <strong>{{details.organization}}</strong>
                                      <div class="val">
                                        <label for="">Validity</label>
                                        <p>16 Aug 2022</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="position">
                                <div class="val ">
                                  <label for="">Position: </label>
                                  <div style="font-size:14px">
                                    <strong>Aws Devops</strong>
                                  </div>
                                </div>
                                <div class="val">
                                  <label for="">Primary Skills:</label>
                                  <span>Angular 2,ASPNET</span>
                                </div>
                              </div>
                              <div class="interestbtn">
                                <!-- <div class="myBookmark"><i class="fa fa-bookmark-o bookmarkicon" aria-hidden="true"></i>     <span> 2.30 pm</span>
</div> -->
                                <div>
                                  <p style="color:purple">Schedule Awaited</p>
                                </div>
                                <button type="button" class="btn btn-success">
                                  <i class="fa fa-check" aria-hidden="true"></i>
                                  Accepted
                                </button>
                              </div>
                            </div>
                            <hr style="margin-top:2px; margin-bottom:6px" />
                            <div class="timeofInterest">
                              <p>Interested Date & Time</p>
                              <p>12 Jul 2022 10:24 am</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- Modal for #mypost -->
    <div
      class="modal fade"
      id="mypost"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title closebtnmodel " id="exampleModalLabel">
              <strong style="font-size:18px">Hi {{firstName.first_name}}</strong>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
          </div>
          <div class="modal-body">
            <div class="myPostArea">
            <div class="postArea">
              <div class="myorgData1">
                <div class="Orgimage">
                  <img
                    class="profile-user-img img-fluid img-circle myprofile"
                    v-if="
                      feedBackdata.profile_picture != '' &&
                      feedBackdata.profile_picture != null
                    "
                    :src="`${feedBackdata.profile_picture}`"
                    alt=""
                  />
                  <img
                    class="round"
                    v-if="
                      feedBackdata.profile_picture == '' ||
                      feedBackdata.profile_picture == null
                    "
                    src="../../../assets/img/default.png"
                    alt=""
                  />
                </div>
                <div class="intDetails">
                  <div class="uniqueId">
                    <div style="font-size:14px">
                      <strong>{{feedBackdata.organization}}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="val ">
                        <label for="" class="labelcss">Position: </label>
                        <div style="font-size:14px">
                          <p class="mytitle">{{feedBackdata.job_tittle}}</p>
                        </div>
                      </div>
              <div class="popupinterestbtn">
                <!-- <button type="button" class="btn btn-danger myBookmark1"> -->
                <!-- <i
                    class="fa fa-thumbs-o-down fa-flip-horizontal bookmarkicon"
                    aria-hidden="true"
                  ></i> -->
                  <div class="mystatus1">
                  <label for="" class="labelcss">Status:</label>
                    <span class="mytitle" v-if="feedBackdata.feedback_status == 'Completed'" style="color: #5bad2b">Completed</span>
                                    <span v-if="feedBackdata.feedback_status == 'Pending'" style="color: #ff2627">Pending</span>                </div>
                <div class="Intcost">
                  <label for="" class="labelcss">InterView Cost:</label>
                  <p class="mystatus ">
                     {{ feedBackdata.currency_symbol }}
                                      {{ feedBackdata.cost }}
                  </p>
                </div>
                <!-- </button> -->
                <!-- <br />
                <div class="myBookmark">
                  <label for="">Validity </label>
                  <p>16 Aug 2022</p>
                </div> -->
              </div>
            </div>
            </div>
            <hr />
            <div class="dateandTime">
              <div class="myDate">
                <label for="" class="labelcss">Interviewed Date - </label>
                <p class="mytitle">{{ feedBackdata.schedule_date | formatDate }}</p>
              </div>
              <div class="divide"></div>
              <div class="myTime">
                <label for="" class="labelcss">Interviewed Time -</label>
                <p class="mytitle">{{ feedBackdata.schedule_start_time }} -
                                      {{ feedBackdata.schedule_end_time }}</p>
              </div>
            </div>
            <!-- <hr>
            <div class="reSchedule">
<button type="button" class="btn btn-danger myBookmark1">
                  <i
                    class="fa fa-times fa-flip-horizontal cancelicon"
                    aria-hidden="true"
                  ></i>
                  Cancel
                </button>
                <button type="button" class="btn btn-success">
              <i class="fa fa-clock-o" aria-hidden="true"></i> Reschedule
            </button>
            </div> -->
            <hr />
            <div class="postDetails">
              <div class="postHead">
                <h4 class="h4">Candidate Details</h4>
              </div>
              <hr />
              <div class="resume">
                <label for="" class="labelcss">Resume</label>
                <!-- <p>{{ mydata.candidate_resume }}</p> -->
                <a type="download" class="btn btn-success mytitle" :href="feedBackdata.candidate_resume">
                  <i
                    class="fa fa-download"
                    aria-hidden="true"
                    @click="downloadResume(feedBackdata)"
                  ></i
                  >  Download
                </a>
              </div>
              <hr />
              <div class=" postDatas">
                <div class="Intdetails">
                  <label for="" class="labelcss">Candidate Name :</label>
                  <p class="mytitle">{{feedBackdata.candidate_name}}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Years of Experience :</label>
                  <p class="mytitle">{{ detailedFeedback.year_of_experience }} years
                    {{ detailedFeedback.month_of_experience }} month</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Primary Skills :</label>
                  <p class="mytitle hidepara">{{feedBackdata.primaryskillnames}}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Secondary Skills :</label>
                  <p class="mytitle">{{feedBackdata.secondaryskillnames}}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Interview type :</label>
                  <p class="mytitle">{{feedBackdata.job_interview_type}}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Remarks :</label>
                  <p class="mytitle">{{feedBackdata.comments}}</p>
                </div>
              </div>
            </div>
            <div class="JobDescription">
              <h4 class="h4">Job Description</h4>
              <hr />
              <p>
                <span>{{feedBackdata.job_comments}}</span>
              </p>
            </div>
            <hr />
            <div class="comments">
              <h4 class="h4">Your Notes (Whiteboard)</h4>
              <hr />
              <div><p>{{feedBackdata.comments}}</p></div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success mytitle" v-if="feedBackdata.feedback_status === 'Completed'" @click="viewFeedback(feedBackdata)">
              <!-- <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>  -->
              View Feedback
            </button>
            <button type="button" class="btn btn-success mytitle" v-if="feedBackdata.feedback_status === 'Pending'" @click="submitFeedback(feedBackdata)">Submit Feedback</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import moment from 'moment'
// import $ from 'jquery'

export default {
  data () {
    return {
      isLoading: true,
      postsearch: '',
      postsort: 30,
      user_id: localStorage.getItem('user_id'),
      fullPage: true,
      myCurrentDate: '',
      myPastDate: '',
      firstName: '',
      feedbackListing: [],
      status: '',
      feedBackdata: [],
      details: [],
      detailedFeedback: [],
      orgName: '',
      orgEmail: '',
      id: ''
    }
  },
  components: {},
  created () {
    localStorage.getItem('_id')
    this.sid = JSON.parse(localStorage.getItem('sid'))
    this.firstName = JSON.parse(localStorage.getItem('user__details'))
    console.log(this.user_id)
    this.feedbackList()
  },
  methods: {
    feedbackList () {
      this.myCurrentDate = moment().format('YYYY-MM-DD')
      console.log(this.myCurrentDate)
      this.myPastDate = moment()
        .subtract(this.postsort, 'days')
        .format('YYYY-MM-DD')
      console.log(this.myPastDate)
      const data = {
        user_id: localStorage.getItem('user_id'),
        sort: this.postsort,
        startdate: this.myPastDate,
        enddate: this.myCurrentDate,
        search: this.postsearch,
        status: this.status
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      // this.$router.push({ name: 'feedbackList' })
      axios
        .post(
          BaseURL + '/dashboard/get_schedule_feedback_list/mobile',
          { formData: data },
          config
        )
        .then(response => {
          this.feedbackListing = response.data.scheduleList
          console.log(this.feedbackListing)
        })
        .catch(error => {
          console.log(error)
        })
    },
    feedbackDetail (data) {
      this.feedBackdata = data
      this.feedBackpage(this.feedBackdata._id)
    },
    feedBackpage (_id) {
      this.scheduleId = _id
      axios.get(BaseURL + '/dashboard/get_schedule_feedback/' + this.scheduleId)
        .then(response => {
          this.detailedFeedback = response.data.feedbackdetails[0]
          console.log(this.detailedFeedback)
        })
        .catch(error => {
          console.log(error)
        })
    },
    viewFeedback (data) {
      this.id = data._id
      this.orgName = data.organization
      this.orgEmail = data.user_email
      var email = this.orgEmail
      var sp = email.split('@')
      let routerPage = ''
      if (sp[1] === 'acsicorp.com') {
        routerPage = this.$router.resolve('/viewfeedback/' + this.id)
      } else {
        routerPage = this.$router.resolve('/viewfeedbackcommon/' + this.id)
      }
      window.open(routerPage.href, '_blank')
    },
    submitFeedback (data) {
      this.id = data._id
      this.orgName = data.organization
      this.orgEmail = data.user_email
      var email = this.orgEmail
      var sp = email.split('@')
      let routerPage = ''
      if (sp[1] === 'acsicorp.com') {
        routerPage = this.$router.resolve('/addfeedback/' + this.id)
      } else {
        routerPage = this.$router.resolve('/addfeedbackcommon/' + this.id)
      }
      window.open(routerPage.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.postArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
}
.postBg {
  background: #f5f5f5;
}
.maincontent {
  background-color: white;
  padding: 10px;
}
.myIntRes {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.tabHeader {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  // background-color: #f5f5f5;
}
.tabHeader .icon {
  display: none;
}
.tabBtn {
  display: flex;
  flex-direction: row;
}
.tabBtn > li > a {
  position: relative;
  display: block;
  // padding: 14px 27px;
  font-size: 14px;
  text-align: center;
}
.tabBtn > li.active > a,
.tabBtn > li.active > a:focus,
.tabBtn > li.active > a:hover {
  color: #fff;
  background-color: #5bad2b;
  border-top-color: unset;
}
.tabBtn > li > a:hover {
  // color: black;
  background-color: white;
}
.profile-user-img {
  margin: 0px auto;
  width: 130px;
  padding: 1px;
  border: 4px solid #d2d6de;
}
.img-circle {
  border-radius: 50%;
}
.myprofile {
  width: 120px;
  height: 120px;
}
.round {
  width: 100px;
  height: 100px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 4px;
}
.uniqueId {
  display: flex;
  text-align: start;
}
.position {
  display: flex;
  text-align: start;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 50%;
}
.Orgname{
  font-size: 16px;
}
.myorgData {
  // width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.myorgData:hover {
  cursor: pointer;
  // background-color: white;
}
.myorgData1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.filterdata {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 8px  0px;
}
.ml-1{
  margin-top: 6px;
 }
// .filterby{
//   align-items: center;
// }
.navTab {
  display: flex;
  justify-content: center;
}
.myBookmark {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
}
.openStatus {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.bookmarkicon {
  font-size: 15px;
}
.cancelicon {
  font-size: 18px;
  -webkit-text-stroke: 1px #d73925;
}
.interestbtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  row-gap: 2px;
  padding-right: 10px;
}
.popupinterestbtn {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: 10px;
  row-gap: 0px;
  align-items: flex-start;
}
.closebtnmodel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}
.val {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: baseline;
  column-gap: 3px;
}
.postDatas {
  display: grid;
  grid-template-columns: 50% 50%;
}
.Intdetails {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
}
.timeofInterest {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0% 1%;
  column-gap: 10px;
}
.postHead {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.sent {
  color: orange;
}
.received {
  color: blue;
}
.tabBtnRes1 {
  width: 50%;
}
.Intcost {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
}
.dateandTime {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.myDate,
.myTime {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  column-gap: 10px;
  font-weight: 600;
}
.divide {
  border-right: 1px solid #d2d6de;
}
.reSchedule {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.resume {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 10px;
  align-content: center;
  align-items: center;
}
.mystatus {
  // width: 80px;
  // border-radius: 10px;
  text-align: center;
}
.mystatusone {
  // width: 100px;
  color: #5bad2b;
  // background-color: #5bad2b;
  border-radius: 10px;
  text-align: center;
}
.mystatus1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: baseline;
  column-gap: 10px;
}
.h4 {
  font-weight: 600;
}
.myline {
  margin-top: 0;
  margin-bottom: 0;
}
.pageTitle {
  font-size: 24px;
  font-weight: 400;
}
.position{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.myPostArea{
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.hidepara{
      line-height: 1.5em;
    height: 1.5em;
    overflow: hidden;
    white-space:wrap;
    text-overflow: ellipsis;
    width: 50%;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {

 .round{
    width: 80px;
    height: 80px;
   }
   .myprofile{
    width: 80px;
    height: 80px;
   }
.labelcss,.valdate{
    font-size: 12px;
   }
   .mytitle,.mystatus{
    font-size: 10px;
   }
   .Orgname{
    font-size: 12px;
   }
   .myorgData{
    flex-direction: column;
   }
   .myorgData1{
flex-direction: column;
row-gap: 5px;
font-size: 12px;
}
.timeofInterest>.val,.labelcss,.valdate{
  font-size: 10px;
}
.position {
  width: 30%;
}
.modal-body{
  padding: 8px;
}
.h4,.pageTitle{
  font-size: 16px;
}
}
</style>
